import L from "leaflet";

// Flèche directionnelle orientée selon le cap (angle en degrés, sens horaire depuis le nord)
export function tripArrowIcon(angle = 0, color = "#17A2B8") {
  return L.divIcon({
    className: "",
    html: `<div class="trip-arrow" style="--c:${color}; transform: rotate(${angle}deg)"></div>`,
    iconSize: [12, 12],
    iconAnchor: [6, 6],
  });
}

// Point (véhicule à l'arrêt / ralenti)
export function tripDotIcon(color = "#EF4444") {
  return L.divIcon({
    className: "",
    html: `<div class="trip-dot" style="--c:${color}"></div>`,
    iconSize: [14, 14],
    iconAnchor: [7, 7],
  });
}

// Marqueur Départ / Arrivée clairement repérable (drapeau étiqueté)
export function tripFlagIcon(kind = "start") {
  const start = kind === "start";
  const color = start ? "#10B981" : "#EF4444";
  const label = start ? "Départ" : "Arrivée";
  return L.divIcon({
    className: "",
    html: `<div class="trip-flag">
             <span class="trip-flag-label" style="--c:${color}">${label}</span>
             <span class="trip-flag-pin" style="--c:${color}"></span>
           </div>`,
    iconSize: [72, 46],
    iconAnchor: [6, 46],
  });
}
